(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
class HeroSlider {
  constructor(slider) {
    this.slider = slider;
    this.track = slider.querySelector('.slider-track');
    this.slides = slider.querySelectorAll('.slide');
    this.prevBtn = slider.querySelector('.slider-arrow--prev');
    this.nextBtn = slider.querySelector('.slider-arrow--next');
    this.dots = slider.querySelectorAll('.slider-dot');
    
    this.currentIndex = 0;
    this.slideCount = this.slides.length;
    this.isAnimating = false;
    this.autoplayTimer = null;
    
    this.autoplay = slider.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(slider.dataset.autoplaySpeed) || 5000;
    this.showArrows = slider.dataset.showArrows === 'true';
    this.showDots = slider.dataset.showDots === 'true';
    
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.isDragging = false;
    this.dragStartX = 0;
    this.dragOffset = 0;
    
    if (this.slideCount < 2) {
      this.autoplay = false;
      if (this.prevBtn) this.prevBtn.style.display = 'none';
      if (this.nextBtn) this.nextBtn.style.display = 'none';
      if (this.dots.length) {
        this.dots.forEach(dot => dot.style.display = 'none');
      }
      return;
    }
    
    if (!this.showArrows) {
      if (this.prevBtn) this.prevBtn.style.display = 'none';
      if (this.nextBtn) this.nextBtn.style.display = 'none';
    }
    
    if (!this.showDots) {
      const dotsContainer = slider.querySelector('.slider-dots');
      if (dotsContainer) dotsContainer.style.display = 'none';
    }
    
    this.init();
  }
  
  init() {
    this.goToSlide(0);
    this.setupEventListeners();
    if (this.autoplay) this.startAutoplay();
  }
  
  goToSlide(index, direction = 1) {
    if (this.isAnimating) return;
    if (this.slideCount < 2) return;
    
    const targetIndex = ((index % this.slideCount) + this.slideCount) % this.slideCount;
    
    if (targetIndex === this.currentIndex && index !== 0) return;
    
    this.isAnimating = true;
    
    const slideWidth = this.slider.offsetWidth;
    this.track.style.transform = `translateX(-${targetIndex * slideWidth}px)`;
    
    this.slides.forEach((slide, i) => {
      slide.classList.remove('active');
      if (i === targetIndex) {
        slide.classList.add('active');
      }
    });
    
    this.updateDots(targetIndex);
    
    setTimeout(() => {
      this.isAnimating = false;
      this.currentIndex = targetIndex;
    }, 750);
  }
  
  nextSlide() {
    if (this.isAnimating) return;
    const nextIndex = (this.currentIndex + 1) % this.slideCount;
    this.goToSlide(nextIndex, 1);
  }
  
  prevSlide() {
    if (this.isAnimating) return;
    const prevIndex = (this.currentIndex - 1 + this.slideCount) % this.slideCount;
    this.goToSlide(prevIndex, -1);
  }
  
  updateDots(index) {
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
      dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
  }
  
  startAutoplay() {
    if (this.autoplayTimer) this.stopAutoplay();
    if (!this.autoplay) return;
    if (this.slideCount < 2) return;
    
    this.autoplayTimer = setInterval(() => {
      this.nextSlide();
    }, this.autoplaySpeed);
  }
  
  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
  
  resetAutoplay() {
    if (!this.autoplay) return;
    this.stopAutoplay();
    this.startAutoplay();
  }
  
  setupEventListeners() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.prevSlide();
        this.resetAutoplay();
      });
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.nextSlide();
        this.resetAutoplay();
      });
    }
    
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        if (this.currentIndex === index) return;
        this.goToSlide(index);
        this.resetAutoplay();
      });
    });
    
    this.slider.addEventListener('mouseenter', () => {
      this.stopAutoplay();
    });
    
    this.slider.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startAutoplay();
    });
    
    this.slider.addEventListener('touchstart', (e) => {
      this.touchStartX = e.changedTouches[0].screenX;
      this.isDragging = true;
      this.stopAutoplay();
    }, { passive: true });
    
    this.slider.addEventListener('touchmove', (e) => {
      if (!this.isDragging) return;
      this.touchEndX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    this.slider.addEventListener('touchend', (e) => {
      if (!this.isDragging) return;
      this.isDragging = false;
      const diff = this.touchStartX - this.touchEndX;
      
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
        this.resetAutoplay();
      } else {
        if (this.autoplay) this.startAutoplay();
      }
    }, { passive: true });
    
    this.slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.prevSlide();
        this.resetAutoplay();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.nextSlide();
        this.resetAutoplay();
      }
    });
    
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const slideWidth = this.slider.offsetWidth;
        this.track.style.transform = `translateX(-${this.currentIndex * slideWidth}px)`;
      }, 250);
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.hero-slider');
  sliders.forEach(slider => {
    new HeroSlider(slider);
  });
});

document.addEventListener('shopify:section:load', function(event) {
  const slider = event.target.querySelector('.hero-slider');
  if (slider) {
    new HeroSlider(slider);
  }
});

document.addEventListener('shopify:section:unload', function(event) {
  const slider = event.target.querySelector('.hero-slider');
  if (slider) {
    const instance = slider._heroSliderInstance;
    if (instance) {
      instance.stopAutoplay();
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
